import {z} from 'zod';

import i18n from '@dms/i18n';

import {vectorTypeSchema} from '../types/MultipleLocationsFormSchema';

const SYMBOL_PATTERN = /^[A-Z]+$|^[0-9]+$/;

const storageLocationItemSchema = z.object({
  isSelected: z.boolean(),
  vectorType: vectorTypeSchema,
  vectorPosition: z.number(),
  symbol: z.string(),
});

export const singleLocationSchema = z
  .object({
    storageLocation: z.array(storageLocationItemSchema),
    note: z.string(),
    allowMultipleUsage: z.boolean(),
  })
  .superRefine((data, ctx) => {
    data.storageLocation.forEach((item, index) => {
      if (!item.isSelected) {
        return;
      }

      if (item.symbol === '') {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          path: ['storageLocation', index, 'symbol'],
          message: i18n.t('general.validations.fieldIsRequired'),
        });
        return;
      }

      if (!SYMBOL_PATTERN.test(item.symbol)) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          path: ['storageLocation', index, 'symbol'],
          message: i18n.t('entity.tireWarehouses.validations.lettersOrNumbers'),
        });
      }
    });
  });
